import "whatwg-fetch";

async function getCsrfToken() {
  const res = await fetch("/csrf-token", {
    credentials: "include",
  });
  const data = await res.json();
  return data.csrfToken;
}

export default async function fetchClient(url, options = {}) {
  const csrfToken = await getCsrfToken();

  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-CSRF-Token": csrfToken,
    ...(options.headers || {}),
  };

  return fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });
}

export const Headers = self.Headers;
export const Request = self.Request;
export const Response = self.Response;
